import { useEffect, useState } from 'react'
import { buildInviteUrl, qrDataUrl, shareInvite } from '../lib/invite'
import { Spinner } from './ui'

const SHARE_TEXT = {
  referral: 'Join me on Beseter - the app for christian songwriters.',
  cowriter: (song) => `Sign in as a co-writer on "${song}" on Beseter.`,
  circle: (circle) => `Join "${circle}", a writers' circle on Beseter.`,
  church_staff: (church) => `${church} is passionate about original songwriting — join the team on Beseter.`,
}

/**
 * The one shared invite surface — a code becomes a QR image, a short link,
 * and a Share button that hands off to whatever the inviter already has
 * open. Nothing here calls the app's own email or SMS; the code is the same
 * regardless of kind, only the caption changes.
 */
export default function InvitePanel({ code, kind, label }) {
  const [qr, setQr] = useState(null)
  const [status, setStatus] = useState(null)

  const url = buildInviteUrl(code)
  const text = typeof SHARE_TEXT[kind] === 'function' ? SHARE_TEXT[kind](label) : SHARE_TEXT[kind]

  useEffect(() => {
    let alive = true
    qrDataUrl(url).then((d) => { if (alive) setQr(d) })
    return () => { alive = false }
  }, [url])

  const share = async () => {
    setStatus(null)
    const result = await shareInvite({ url, text })
    if (result === 'copied') setStatus('Copied — paste it into a text.')
    if (result === 'unsupported') setStatus('Copy the link below to share it.')
  }

  return (
    <div className="tile invite-panel">
      {qr ? <img src={qr} alt="Invite QR code" width={160} height={160} /> : <Spinner />}
      <p className="small" style={{ marginTop: 10, wordBreak: 'break-all' }}>{url}</p>
      <button className="btn btn-primary" onClick={share}>Share</button>
      {status && <p className="small" style={{ marginTop: 8 }}>{status}</p>}
    </div>
  )
}
